<div class="mdc-layout-grid__inner">
	<div class="mdc-layout-grid__cell--span-12">
		<app-premvip-tab></app-premvip-tab>
	</div>

	<div class="mdc-layout-grid__cell--span-12">
		<div class="ad">
			<div class="cover">
				<img *ngIf="locale.lang == 'en'" [src]="enPremiumImage" />

				<img *ngIf="locale.lang == 'ku'" [src]="kuPremiumImage" />

				<img *ngIf="locale.lang == 'ar'" [src]="arPremiumImage" />
			</div>
		</div>
	</div>

	<div class="mdc-layout-grid__cell--span-12">
		<h4 class="purple" id="n96">{{ locale.translations['premium']['n96'] }}</h4>

		<ul class="list li-padding">
			<li id="n97">
				<mat-icon color="primary">verified_user</mat-icon>
				&nbsp;

				<span>{{ locale.translations['premium']['n97'] }}</span>
			</li>

			<li id="n98">
				<mat-icon color="primary">verified_user</mat-icon>
				&nbsp;

				<span>{{ locale.translations['premium']['n98'] }}</span>
			</li>

			<li id="n99">
				<mat-icon color="primary">verified_user</mat-icon>
				&nbsp;

				<span>{{ locale.translations['premium']['n99'] }}</span>
			</li>

			<li id="n100">
				<mat-icon color="primary">verified_user</mat-icon>
				&nbsp;

				<span>{{ locale.translations['premium']['n100'] }}</span>
			</li>
		</ul>
	</div>

	<div class="mdc-layout-grid__cell--span-12">
		<mat-divider></mat-divider>
	</div>

	<div class="mdc-layout-grid__cell--span-12">
		<h4 class="purple" id="n101">{{ locale.translations['premium']['n101'] }}</h4>

		<div class="pay-btn-cont">
			<a
				class="w-100"
				[routerLink]="[embedded ? '/payment/temp' : '/payment']"
				[queryParams]="{ package: 'premium', adID: queryAdID, embedded: embedded }"
				mat-flat-button
				color="primary"
			>
				{{ locale.translations['ads']['ad']['n390'] }}
			</a>

			<div class="text-center font-weight-semi-bold" style="padding: 1.125em 0">
				{{ locale.translations['ads']['ad']['n391'] }}
			</div>
		</div>

		<div class="list-padding phone_cont">
			<span class="altPay" id="n102">{{ locale.translations['premium']['n102'] }}</span>

			<ul class="list">
				<li id="n103">
					<a href="tel:07512347071">
						<mat-icon class="mat-icon-rtl-mirror" color="primary">call</mat-icon>
						&nbsp;

						<span>{{ locale.translations['premium']['n103'] }}</span>
					</a>
				</li>

				<li id="n104">
					<a href="tel:07706921858">
						<mat-icon class="mat-icon-rtl-mirror" color="primary">call</mat-icon>
						&nbsp;

						<span>{{ locale.translations['premium']['n104'] }}</span>
					</a>
				</li>
			</ul>

			<span id="n105">{{ locale.translations['premium']['n105'] }}</span>
		</div>
	</div>
</div>
